import { init } from '@sentry/browser'

if (process.env.NODE_ENV == 'production' && process.env.SENTRY_DSN ) {
  init({ dsn: process.env.SENTRY_DSN })
}
